import { Typography } from 'antd';
import type { FC, ReactNode } from 'react';
import useDocumentTitle from '@hooks/useDocumentTitle';
import styles from './styles.module.scss';

const { Title } = Typography;

type PageTitleProps = {
	children: ReactNode;
	/** Explicit tab title; overrides string children. Falsy → app default. */
	documentTitle?: string;
};

const PageTitle: FC<PageTitleProps> = ({ children, documentTitle }) => {
	const title = documentTitle ?? (typeof children === 'string' ? children : '');

	useDocumentTitle(title);

	return (
		<Title
			level={1}
			className={styles.pageTitle}
		>
			{children}
		</Title>
	);
};

export default PageTitle;
